import { Box, Grid, Typography } from '@mui/material';
import UserFields from '@features/workspace/components/users/components/user-details-fields';
import AddressFields from '@features/workspace/components/users/components/address-fields';
import { UserManagementMode } from '@features/workspace/components/users/utils/constants';
import { FC } from 'react';

const UserForm: FC<any> = ({
  data,
  register,
  errors,
  control,
  type = UserManagementMode.Director,
  openChangeEmail,
  pendingEmail,
}) => {
  return (
    <Grid container spacing={9}>
      {/* Left side */}
      <Grid item md={6}>
        <Box display="flex" flexDirection="column" flexGrow={1}>
          <Box display="flex">
            <Typography variant="legend">
              {type === UserManagementMode.Director
                ? 'Director details'
                : 'Authorised person details'}
            </Typography>
          </Box>
          <Box display="flex" flexDirection="column">
            <UserFields
              control={control}
              data={data}
              errors={errors}
              isAuthPerson={type === UserManagementMode.AuthPerson}
              openChangeEmail={openChangeEmail}
              pendingEmail={pendingEmail}
              register={register}
              type={type}
            />
          </Box>
        </Box>
      </Grid>
      {/* Right side */}
      <Grid item md={6}>
        <Box display="flex" flexDirection="column" flexGrow={1}>
          <Box display="flex">
            <Typography variant="legend">
              {type === UserManagementMode.Director
                ? 'Director address'
                : 'Authorised person address'}
            </Typography>
          </Box>
          <Box display="flex" flexDirection="column">
            <AddressFields
              control={control}
              data={data.address}
              errors={errors}
              register={register}
              type={type}
            />
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};

export default UserForm;
